import { getRandomArrayElement } from '@root/src/utils/global';
import { BallColor, WinType } from '../../../src/types';

export function getTopSlotWinTypes(): WinType[] {
    return ['MULT_1', 'MULT_2', 'MULT_5', 'MULT_10', 'BALL_SPIN', 'PLINKO', 'CASH_REELS', 'FORTUNE_WHEEL'];
}

export function getCustomBTCParams() {
    return getCustomParams(getBTCMaxLimits, getBTCChipLimits, getBTCChipPrice);
}
export function getCustomParams(getMaxLimits = getUSDTMaxLimits, getChipLimits = getUSDTChipLimits, getChipPrice = getUSDTChipPrice) {
    return {
        return_url: 'https://dev.clawbastards.com',
        game_type: 'CRAZY_CRAZY_CLAW',
        ab: {
            video: '3d'
        },
        chip_price: getChipPrice(),
        chip_limits: getChipLimits(),
        game_config: getMaxLimits()
    };
}

//USDT
export function getUSDTMaxLimits() {
    return {
        limit_bets_plinko: 10526315800,
        limit_bets_10: 26316000000,
        limit_bets_5: 26316000000,
        limit_bets_ball_spin: 10526315800,
        limit_bets_cash_reels: 10526315800,
        limit_bets_1: 26316000000,
        limit_bets_fortune_wheel: 10526315800,
        limit_bets_2: 26316000000
    };
}

export function USDTBetLimits() {
    return [
        10000000, 20000000, 50000000, 100000000, 200000000, 400000000, 600000000, 800000000, 1000000000, 1200000000,
        1400000000, 1600000000, 1800000000, 2000000000
    ];
}

export function getUSDTChipPrice() {
    return 100000000;
}

export function getUSDTChipLimits() {
    return ['0.1', '0.5', '1', '2', '5', '10', '20', '50'];
}

export function getUSDTCurrencyAttributes() {
    return {
        code: 'USDT',
        symbol: 'USDT',
        exponent: 8,
        subunits: 2,
        crypto: true
    };
}

//BTC
export function getBTCChipPrice() {
    return 200;
}

export function getBTCChipLimits() {
    return ['1', '2', '5', '10', '20', '50', '100', '200'];
}

export function getBTCMaxLimits() {
    return {
        limit_bets_plinko: 79608,
        limit_bets_10: 398000,
        limit_bets_5: 398000,
        limit_bets_ball_spin: 79608,
        limit_bets_cash_reels: 79608,
        limit_bets_1: 398000,
        limit_bets_fortune_wheel: 79608,
        limit_bets_2: 398000
    };
}

export function getBTCBetLimits() {
    return [200, 500, 1000, 2000, 4000, 6000, 8000, 10000, 15000, 20000, 25000, 30000, 50000, 75000];
}

export function getBTCCurrencyAttributes() {
    return {
        code: 'BTC',
        symbol: 'BTC',
        exponent: 8,
        subunits: 6,
        crypto: true
    };
}

const colors: BallColor[] = ['PURPLE', 'LIGHT_BLUE', 'BLACK', 'ORANGE'];
export function getRandomNonBonusBallColor(): BallColor {
    return getRandomArrayElement(colors);
}

let balance = 1000000000;
export function getBalance() {
    return balance;
}

export function setBalance(val: number) {
    balance = val;
}
